import {
  FormControl,
  FormHelperText,
  FormLabel,
  Stack,
  TextField,
} from '@mui/material';
import { useState } from 'react';

import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';

import type { UpsertSamlState } from './upsertSamlFlow';

const PROVIDER_NAME_PATTERN =
  '[^_\\p{Z}][\\p{L}\\p{M}\\p{S}\\p{N}\\p{P}][^_\\p{Z}]+';

const providerNameErrorText = `Provider name must satisfy regular expression pattern: ${PROVIDER_NAME_PATTERN}`;

export const UpsertSamlStep = (props: StepProps<UpsertSamlState>) => {
  const [providerNameError, setProviderNameError] = useState('');

  const handleProviderNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    props.setWizardState((state) => ({
      ...state,
      providerName: event.target.value,
    }));

    setProviderNameError(
      event.target.validity.patternMismatch ? providerNameErrorText : ''
    );
  };

  return (
    <StepContainer
      hideStepper
      onBackClick={props.back}
      canGoNext={() =>
        !providerNameError &&
        !!props.wizardState.providerName &&
        !!props.wizardState.ssoUrl &&
        !!props.wizardState.issuerUrl &&
        !!props.wizardState.certificate
      }
      nextButtonText={props.wizardState.id ? 'Save Changes' : 'Create'}
      backButtonText='Cancel'
      onNextClick={async () => {
        await props.finish();
      }}
    >
      <Stack gap='24px' className='px-[60px] py-[12px] w-[50%]'>
        <FormControl size='small' className='w-full'>
          <FormLabel>Provider name</FormLabel>
          <TextField
            size='small'
            value={props.wizardState.providerName}
            onChange={handleProviderNameChange}
            error={!!providerNameError}
            slotProps={{
              htmlInput: {
                pattern: PROVIDER_NAME_PATTERN,
                title: providerNameErrorText,
              },
            }}
          />
          {providerNameError && (
            <FormHelperText>{providerNameError}</FormHelperText>
          )}
        </FormControl>
        <FormControl size='small' className='w-full'>
          <FormLabel>SSO URL</FormLabel>
          <TextField
            size='small'
            value={props.wizardState.ssoUrl}
            onChange={(event) =>
              props.setWizardState((state) => ({
                ...state,
                ssoUrl: event.target.value,
              }))
            }
          />
        </FormControl>
        <FormControl size='small' className='w-full'>
          <FormLabel>Issuer URL</FormLabel>
          <TextField
            size='small'
            value={props.wizardState.issuerUrl}
            onChange={(event) =>
              props.setWizardState((state) => ({
                ...state,
                issuerUrl: event.target.value,
              }))
            }
          />
        </FormControl>
        <FormControl size='small' className='w-full'>
          <FormLabel>Logout URL</FormLabel>
          <TextField
            size='small'
            value={props.wizardState.logoutUrl}
            onChange={(event) =>
              props.setWizardState((state) => ({
                ...state,
                logoutUrl: event.target.value,
              }))
            }
          />
        </FormControl>
        <FormControl size='small' className='w-full'>
          <FormLabel>Certificate</FormLabel>
          <TextField
            multiline
            sx={{ textarea: { padding: 0 } }}
            size='small'
            value={props.wizardState.certificate}
            onChange={(event) =>
              props.setWizardState((state) => ({
                ...state,
                certificate: event.target.value,
              }))
            }
          />
        </FormControl>
      </Stack>
    </StepContainer>
  );
};
